import { useMatches } from 'react-router-dom'

/**
 * Hook to access breadcrumb data from React Router v7 loader data
 *
 * Returns an object with breadcrumb labels keyed by their IDs:
 * - planId -> plan name
 * - workcentreId -> workcentre name
 *
 * This data comes from the router loaders that call fetchBreadcrumbsLabels
 */
export const useBreadcrumbData = (): Record<string, string> => {
  const matches = useMatches()

  // Extract breadcrumb data from router matches
  const breadcrumbsData = matches.reduce(
    (acc, match) => {
      if (match.data) {
        // Collect plan name from plan route loader
        if (match.data.planName && match.params?.planId) {
          acc[match.params.planId] = match.data.planName
        }
        // Collect workcentre name from workcentre route loader
        if (match.data.workcentreName && match.params?.workcentreId) {
          acc[match.params.workcentreId] = match.data.workcentreName
        }
      }
      return acc
    },
    {} as Record<string, string>
  )

  return breadcrumbsData
}
